// extracted by mini-css-extract-plugin
export default {"root":"header_root__F2TFS","header-title-row":"header_header-title-row__c-uGE","input-container":"header_input-container__PEYZF","plan-error":"header_plan-error__yo6q4"};